<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div v-bind:class="{ wrapper: ready, hide: !ready }">
          <iframe id="display" v-bind:class="{ hide: !ready }" allowfullscreen>
            <p>Your browser does not support iframes.</p>
          </iframe>
        </div>
        <div v-if="!ready"><h4>Loading...</h4></div>
      </div>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: 'UrlHTML',
  props: {
    data: {
      type: Object
    }
  },
  data: () => ({
    error: undefined,
    ready: false
  }),
  beforeMount () {
    this.fetchUrlContent()
  },
  methods: {
    fetchUrlContent () {
      this.$http
        .get(this.data.url, {}, { headers: { 'Accept': 'text/html' } })
        .then(response => {
          this.ready = true
          document.getElementById('display').src = `data:text/html;charset=utf-8,${escape(response.data)}`
        })
        .catch(err => {
          this.error = `Failed to fetch URL content: ${err}`
        })
    }
  }
}
</script>

<style scoped>
.wrapper {
  height: 420px;
}
.wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.hide {
  display: none;
}
</style>
